jQuery(function($) {
    var affiliates = {
        onCountryChange: function() {
            var self = this;
            if($('#filter-by-country')) {
                $('#filter-by-country').on('change', function(e) {
                    var selected = e.target.value;
                    self.showHideAffiliates(selected);
                    self.selectCountry(selected);
                });
            }
        },

        changeCountry: function(country) {
            var self = this;
            if($('#filter-by-country')) {
                $('#filter-by-country').val(country);
            }
            self.showHideAffiliates(country);
        },

        showHideAffiliates: function(country) {
            if(country !== 'All') {
                $('.country-wrap').hide();
                $('.affiliate-country-' + country).show();
            } else {
                $('.country-wrap').show();
            }
        },

        selectCountry: function(country) {
            for ( var i in map.dataProvider.areas ) {
                var area = map.dataProvider.areas[ i ];
                if ( area.showAsSelected ) {
                  area.showAsSelected = false;
                }
                if(area.id === country) {
                 area.showAsSelected = true;   
                }
            }
            map.validateData();
        }
    };


    affiliates.onCountryChange();

    var areas = [];
    $('#filter-by-country option').each(function(index, value) {
        if($(this).val() !== 'All') {
            areas.push({id: $(this).val()});
        }
    });

    var map = AmCharts.makeChart( "chartdiv", {
      "type": "map",
      "theme": "light",
      "projection": "miller",
      "dataProvider": {
        "map": "worldLow",
        "getAreasFromMap": false,
        "zoomLevel": 3.5,
        "zoomLongitude": 10,
        "zoomLatitude": 52,
        "areas": areas,
      },
      "areasSettings": {
        "selectedColor": "#CC0000",
        "selectable": true
      },
      "listeners": [ {
          "event": "clickMapObject",
          "method": function( event ) {
            affiliates.changeCountry(event.mapObject.id);
            for ( var i in map.dataProvider.areas ) {
                var area = map.dataProvider.areas[ i ];
                if ( area.showAsSelected ) {
                  area.showAsSelected = false;
                }
                if(area.id === event.mapObject.id) {
                 area.showAsSelected = true;   
                }
            }
            map.validateData();
          }
        } ],
    } );

});